import React, { useState } from "react"
import { usePagination } from "../../../../hooks/usePagination"
import ResultHandler from "../../../../components/ResultHandler"
import PaginationHandler from "../../../../components/PaginationHandler"
import TableHeaderHandler from "../../../../components/TableHeaderHandler"
import { useTranslation } from "react-i18next"
import TableAction from "../../../../components/TableAction"
import EmptyData from "../../../../components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../../api/permissions";
import { useResponse } from "../../../../hooks/useResponse"
import DeleteModal from "../../../../components/Common/DeleteModal"
import { formatCurrency } from "../../../../utils/formatCurrency"
import { useParams } from "react-router-dom"
import moment from "moment"
import { deletePersonalUse, getAllPersonalUse } from "../../../../api/personal-use"

export default function PersonalUseTable() {
  const { t } = useTranslation()
  const {reservationId} = useParams()

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
    setMeta
  } = usePagination(getAllPersonalUse, {reservation_id: reservationId})

  // delete
  const [show, setShow] = useState(false)
  const [deletingPersonalUse, setDeletingPersonalUse] = useState(null)

  const { setData } = useResponse(deletePersonalUse, () => {
    setShow(false)
    setDeletingPersonalUse(null)
    setPayload({ref: true, reservation_id: reservationId})
  })

  function onDeleteClick() {
    setData({ type: "delete", data: deletingPersonalUse })
  }

  function onCloseClick() {
    setShow(false)
  }


  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.RESERVATION_CREATE}
        addUrl={`/add-personal-use/${reservationId}`}
        setPage={setPage}
        setPerPage={setPerPage}
      >
      </TableHeaderHandler>

      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th>Date</Th>
                <Th>Cost</Th>
                <Th>Kilometers</Th>
                <Th>Description</Th>
                <Th className="d-flex">{t("tables.Action")}</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.privateUses.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td>{row.date && moment(row.date).format('DD MMM YYYY')}</Td>
                      <Td>{formatCurrency(row.cost)}</Td>
                      <Td>{row.kilometers}</Td>
                      <Td>{row.description}</Td>
                      <Td className="d-flex">
                        <TableAction
                          hasEdit={true}
                          editPermission={PERMISSIONS.RESERVATION_EDIT}
                          hasDelete={true}
                          deletePermission={PERMISSIONS.RESERVATION_DELETE}
                          type="personal-use"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingPersonalUse}
                        />
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading &&
            <EmptyData empty={response.data && response.data.privateUses.length === 0} msg="No Data Found." />
          }

          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}
     
          <ResultHandler error={error} loading={loading} />
        </div>
      </div>
    </>
  )
}
